import { mpEventInfo } from '@/constant'
import type { Scenario, SubScenario } from '@/dto'
import type { DefaultResponse } from '@/types'
import maxios from '@/utils/axios/maxios'

// 출석 API
const scenarioApi = {
  // 선생님 시나리오 정보 조회
  getUserScenario: () => {
    return maxios.get<DefaultResponse<res.FinishedScenarioId>>('scenario/action/log', {
      params: { mp_event_name: mpEventInfo.시나리오_유저_조회 },
    })
  },
  // 선생님 시나리오 유닛 추가/변경
  postScenario: (id: Scenario['id']) => {
    return maxios.post<DefaultResponse<req.Scenario>>(
      'scenario/action/log',
      { unitId: id },
      {
        params: { mp_event_name: mpEventInfo.시나리오_유저_수행 },
      },
    )
  },
  getLatestAssignedStudent() {
    return maxios.get<DefaultResponse<res.Student['id']>>('scenario/latest/assignment', {
      params: { mp_event_name: mpEventInfo.시나리오_마지막_출제학생 },
    })
  },
  getLatestScoredStudent() {
    return maxios.get<DefaultResponse<res.Student['id']>>('scenario/latest/scoring', {
      params: { mp_event_name: mpEventInfo.시나리오_마지막_채점학생 },
    })
  },
  deleteSubScenario(id: SubScenario['id']) {
    return maxios.delete<any, any, req.Scenario>('scenario/action/log', {
      data: { unitId: id },
      params: { mp_event_name: mpEventInfo.시나리오_유저_수행취소 },
    })
  },
}

export default scenarioApi
